import React from 'react';
import './about.css';
import ME from '../../assets/me-about.jpg';
import IMG1 from '../../assets/IMG1.jpg';
import IMG2 from '../../assets/IMG2.jpg';
import IMG3 from '../../assets/IMG3.jpg';
import IMG4 from '../../assets/IMG4.jpg';
import {FaAward} from 'react-icons/fa';
import {FiUsers} from 'react-icons/fi';
import {VscFolderLibrary} from 'react-icons/vsc';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
// import swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


// install Swiper modules
SwiperCore.use([Navigation]);


const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <Swiper 
          className='about__me'
          modules={[Pagination, Navigation]}
          navigation={true}
          slidesPerView={1}
          spaceBetween={40}
          slidesPerGroup={1}
        >

          <SwiperSlide className="about__me-image" >
              <img src={ME} alt="about"/>
          </SwiperSlide>
          <SwiperSlide className="about__me-image" >
              <img src={IMG4} alt="IMG4"/>
          </SwiperSlide>
          <SwiperSlide className="about__me-image" >
              <img src={IMG1} alt="IMG1"/>
          </SwiperSlide>
          <SwiperSlide className="about__me-image" >
              <img src={IMG3} alt="IMG3"/>
          </SwiperSlide>
          <SwiperSlide className="about__me-image" >
              <img src={IMG2} alt="IMG2"/>
          </SwiperSlide>
        </Swiper>
          
        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>9+ months Working</small>
            </article>

            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Clients+</h5>
              <small>10+ WorldWide</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>10+ Completed</small>
            </article>
          </div>

          <p>
          Front-End Developer with proven experience with Javascript in creating and maintaining a better code base for reusability. Passionate about learning and development with a desire to apply skills, to also join a team with whom communication and teamwork are paramount. Eager to tackle problems and also find ways to maximize user efficiency.
          </p>

          <a href="#contact" className='btn btn-primary'>Let's talk</a>
        </div>
      </div>
    </section>
  )
}

export default About